import React, {useEffect, useRef, useState} from 'react';
import style from './style.module.scss';
import CardWrapper from "./components/CardWrapper/ui/CardWrapper";
import WorkDirectionScroll from "./components/WorkDirection/ui/WorkDirection";
import CommandScroll from "./components/Command/ui/Command";
import ContactForm from "./components/ContactForm/ui/ContactFrom";
import LeftSpiral from "./images/background/leftSpiral.svg"
import RightSpiral from "./images/background/rightSpiral.svg"
import MainImage from "./images/main/main_image.png"
import Footer from "./components/Footer/ui/Footer";
import Navigation from "./components/Navigation/ui/Navigation";
import Loader from "./components/Loader/ui/Loader";
import {CompanyInfo, getCompanyInfo} from "./axios/api"
import {MainActivity} from "./components/MainActivity";
import {Projects} from "./components/Projects";
import {Licenses} from "./components/Licenses";
import BG from './images/background/contacts_pattern.svg'

const useElementOnScreen = (): [React.RefObject<HTMLImageElement | null>, boolean] => {
    const ref = useRef<HTMLImageElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (ref.current && window.innerWidth <= 800) {
                const isIntersecting = window.scrollY <= 1;
                setIsVisible(isIntersecting);
            } else {
                setIsVisible(window.scrollY <= 1);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Initial check
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return [ref, isVisible];
};

function App() {
    const [companyInfo, setCompanyInfo] = useState<CompanyInfo | null>(null)
    const sendFormSectionRef = useRef(null)
    const [loader, setLoader] = useState(false)
    const duration = 2000;

    useEffect(() => {
        const id = 1;
        getCompanyInfo(id).then(setCompanyInfo).catch(console.error);
        setTimeout(() => setLoader(true), duration);
    }, []);

    const [ref, isVisible] = useElementOnScreen();

    if (!loader) {
        return (
            <Loader companyName={"Нейросеть-Агро"} duration={duration}/>
        )
    }
    return (
        <div className={style.app}>
            <div className={style.main}>
                <div className={style.container} style={{zIndex: "300"}}>
                    <Navigation navigationRef={sendFormSectionRef} logo={companyInfo?.logo}
                                supportNumber={companyInfo?.support_phone_number}/>

                    <div className={style.informationContainer}>
                        <div className={style.companyInfo}>
                            <h1 className={style.name}>{companyInfo?.company_name}</h1>
                            <div className={style.description}>{companyInfo?.work_direction}
                            </div>
                        </div>
                        <img ref={ref} className={style.mainImage} src={MainImage}
                             alt={"background lion, only on desktop to phone"}
                             style={window.innerWidth <= 800 ? {
                                 transformOrigin: "bottom center",
                                 transition: "transform 1.4s ease",
                                 transform: isVisible ? "scale(1)" : "scale(1.1)"
                             } : {
                                 transformOrigin: "bottom center",
                                 transition: "transform 1.2s ease",
                                 transform: isVisible ? "scale(1)" : "scale(1.05)"
                             }}
                        ></img>
                        <CardWrapper/>
                    </div>
                </div>
            </div>
            <MainActivity/>
            <WorkDirectionScroll style={{zIndex: "900"}}/>
            <Projects/>
            <Licenses/>

            <div className={style.formMain} style={{zIndex: "1"}}>
                <img src={BG} className={style.pattern}/>
                <div className={style.container}>
                    <div className={style.informationContainer}>
                        <div ref={sendFormSectionRef}>
                            <ContactForm segment={companyInfo?.work_segment} politic={companyInfo?.send_button_politic}
                                         title={companyInfo?.send_form_title}
                                         subtitle={companyInfo?.send_form_subtitle}/>
                        </div>
                    </div>
                </div>
            </div>
            <Footer companyInfo={{
                logo_footer: companyInfo?.logo_footer,
                company_name: companyInfo?.company_name,
                company_name_ru: companyInfo?.company_name_ru,
                TIN: companyInfo?.TIN, OGRNEP: companyInfo?.OGRNIP,
                phone_number: companyInfo?.support_phone_number,
                email: companyInfo?.support_email,
                license: companyInfo?.license,
                address: companyInfo?.address, person_data_politic: companyInfo?.person_data_politic,
                licence_url: companyInfo?.licence_url || companyInfo?.licence_file || null
            }}
            />
        </div>
    );
}

export default App;